import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck, Truck, Heart } from "lucide-react";
import heroImg from "@/assets/bestseller-zorro-hero.jpeg";
import MagentaBand from "@/components/MagentaBand";
import ProtectedImage from "@/components/ProtectedImage";

const trustPoints = ["Desde $350 MXN", "Entrega en 7–10 días", "Envíos a todo México"];

const trustBadges = [
  { icon: Truck, label: "Envíos a todo México" },
  { icon: ShieldCheck, label: "Pago seguro" },
  { icon: Heart, label: "Hecho con amor en MX" },
];

const HeroSection = () => {
  return (
    <section className="pt-28">
      {/* Bloque editorial centrado, estilo Wix */}
      <div className="max-w-4xl mx-auto px-6 pt-12 pb-20 text-center space-y-8 animate-fade-up">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-light leading-[1.05] tracking-tight text-foreground">
          Convierte a tu mascota en <span className="text-secondary">arte pop único</span>
        </h1>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Elige tu tipo de merch, escoge el estilo, sube la foto de tu mascota y recíbelo en tu casa en días.
        </p>
        <div className="pt-2 flex flex-wrap justify-center gap-4">
          <Link
            to="/pedir-retrato"
            className="inline-block bg-primary text-primary-foreground px-10 py-4 rounded-full font-medium text-base hover:opacity-90 transition-opacity duration-200"
          >
            Crear el mío
          </Link>
        </div>
        <ul className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-sm font-medium text-foreground pt-2">
          {trustPoints.map((point) => (
            <li key={point} className="inline-flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              {point}
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 pt-4 border-t border-border/50 mt-4">
          {trustBadges.map(({ icon: Icon, label }) => (
            <div key={label} className="inline-flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
              <Icon className="w-4 h-4 text-secondary" />
              <span className="font-medium">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Banda magenta */}
      <MagentaBand />

      {/* Imagen ancho completo — recorte enfocado en el lienzo, sin tanto aire blanco */}
      <div className="w-full bg-background overflow-hidden">
        <ProtectedImage
          src={heroImg}
          alt="Retrato pop art de un zorro durmiendo, enmarcado en una sala moderna - best seller PAWTRAiT"
          className="w-full h-[55vh] sm:h-[65vh] md:h-[70vh] lg:h-[78vh] max-h-[820px] object-cover object-[center_42%] block"
          loading="eager"
          // @ts-expect-error React 18 requires lowercase fetchpriority to render the attribute
          fetchpriority="high"
          decoding="async"
          width={1056}
          height={1006}
        />
      </div>
    </section>
  );
};

export default HeroSection;
